import React from 'react';
import Text from 'components/Text';

const AutoCompleteManagerModel: React.FC = (props: any) => {
  const { item } = props;
  return (
    <>
      <Text className="text-left color-blue-gray pt-1" size={13}>
        {item.email}
      </Text>
    </>
  );
};

export default AutoCompleteManagerModel;
